/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ConnectionStatus,
  IntegrationServiceCombined,
  MapString,
  MapUserIdOptionDateTime,
  MapUserIdStatusAndWait,
  UserId,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "integration-notifications";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Get list of all users in given tenant for given integration that are in given connection status and optionally until when do they have to wait to be able to notify them again. read-only
   *
   * @tags IntegrationNotifications
   * @name GetAllUsersWithConnectionStatus
   * @request GET:/v1/tenant/{tenantId}/integration/{integration}/integrationStatus/{connectionStatus}
   * @secure
   */
  getAllUsersWithConnectionStatus = (
    tenantId: string,
    integration: string,
    connectionStatus: ConnectionStatus,
    params: RequestParams = {},
  ) =>
    this.request<
      MapUserIdOptionDateTime,
      | UserId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/integration/${integration}/integrationStatus/${connectionStatus}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getAllUsersWithConnectionStatus */
  getAllUsersWithConnectionStatusPathGetter = (
    tenantId: string,
    integration: string,
    connectionStatus: ConnectionStatus,
  ) => this.getServicePath(`/v1/tenant/${tenantId}/integration/${integration}/integrationStatus/${connectionStatus}`);

  /**
   * @description Get list of all users in given tenant for given integration with connection statuses and optionally until when do they have to wait to be able to notify them again. read-only
   *
   * @tags IntegrationNotifications
   * @name GetAllUsersConnectionStatus
   * @request GET:/v1/tenant/{tenantId}/integration/{integration}
   * @secure
   */
  getAllUsersConnectionStatus = (tenantId: string, integration: string, params: RequestParams = {}) =>
    this.request<
      MapUserIdStatusAndWait,
      | UserId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/integration/${integration}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getAllUsersConnectionStatus */
  getAllUsersConnectionStatusPathGetter = (tenantId: string, integration: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/integration/${integration}`);

  /**
   * @description Send notification to all users that have integration either NeverConnected, InTrouble or Disconnected
   *
   * @tags IntegrationNotifications
   * @name NotifyAllIntegrationNotConnected
   * @request POST:/v1/tenant/{tenantId}/integration/{integration}/notifyIntegrationNotConnected
   * @secure
   */
  notifyAllIntegrationNotConnected = (tenantId: string, integration: string, params: RequestParams = {}) =>
    this.request<
      void,
      | UserId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/integration/${integration}/notifyIntegrationNotConnected`,
      method: "POST",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for notifyAllIntegrationNotConnected */
  notifyAllIntegrationNotConnectedPathGetter = (tenantId: string, integration: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/integration/${integration}/notifyIntegrationNotConnected`);

  /**
   * @description Send notification to users about integration either NeverConnected, InTrouble or Disconnected
   *
   * @tags IntegrationNotifications
   * @name NotifyUserIntegrationNotConnected
   * @request POST:/v1/tenant/{tenantId}/integration/{integration}/notifyUserIntegrationNotConnected
   * @secure
   */
  notifyUserIntegrationNotConnected = (
    tenantId: string,
    integration: IntegrationServiceCombined,
    data?: UserId[],
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | UserId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/integration/${integration}/notifyUserIntegrationNotConnected`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for notifyUserIntegrationNotConnected */
  notifyUserIntegrationNotConnectedPathGetter = (tenantId: string, integration: IntegrationServiceCombined) =>
    this.getServicePath(`/v1/tenant/${tenantId}/integration/${integration}/notifyUserIntegrationNotConnected`);

  /**
   * @description Send notification to users about integration being NeverConnected
   *
   * @tags IntegrationNotifications
   * @name NotifyIntegrationNeverConnected
   * @request POST:/v1/tenant/{tenantId}/integration/{integration}/notifyIntegrationNeverConnected
   * @secure
   */
  notifyIntegrationNeverConnected = (
    tenantId: string,
    integration: string,
    data?: UserId[],
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | UserId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/integration/${integration}/notifyIntegrationNeverConnected`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for notifyIntegrationNeverConnected */
  notifyIntegrationNeverConnectedPathGetter = (tenantId: string, integration: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/integration/${integration}/notifyIntegrationNeverConnected`);

  /**
   * @description Send notification to users about integration being InTrouble
   *
   * @tags IntegrationNotifications
   * @name NotifyIntegrationInTrouble
   * @request POST:/v1/tenant/{tenantId}/integration/{integration}/notifyIntegrationInTrouble
   * @secure
   */
  notifyIntegrationInTrouble = (tenantId: string, integration: string, data?: UserId[], params: RequestParams = {}) =>
    this.request<
      void,
      | UserId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/integration/${integration}/notifyIntegrationInTrouble`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for notifyIntegrationInTrouble */
  notifyIntegrationInTroublePathGetter = (tenantId: string, integration: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/integration/${integration}/notifyIntegrationInTrouble`);

  /**
   * @description Send notification to users about integration being Disconnected
   *
   * @tags IntegrationNotifications
   * @name NotifyIntegrationDisconnected
   * @request POST:/v1/tenant/{tenantId}/integration/{integration}/notifyIntegrationDisconnected
   * @secure
   */
  notifyIntegrationDisconnected = (
    tenantId: string,
    integration: string,
    data?: UserId[],
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | UserId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/integration/${integration}/notifyIntegrationDisconnected`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for notifyIntegrationDisconnected */
  notifyIntegrationDisconnectedPathGetter = (tenantId: string, integration: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/integration/${integration}/notifyIntegrationDisconnected`);
}
